import { render, staticRenderFns } from "./dashboard-v3.vue?vue&type=template&id=19ea9016&scoped=true&"
import script from "./dashboard-v3.vue?vue&type=script&setup=true&lang=js&"
export * from "./dashboard-v3.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./dashboard-v3.vue?vue&type=style&index=0&id=19ea9016&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ea9016",
  null
  
)

export default component.exports